import groupBy from 'lodash/groupBy.js'
import {ProjectId} from '../../projects/index.js'
import type {Recommendation} from '../Recommendation.js'

export type RecommendationsByProjectId = {projectId: ProjectId; recommendations: Recommendation[]}[]

export const groupRecommendationsByProjectId = (recommendations: Recommendation[]): RecommendationsByProjectId => {
  return Object.entries(groupBy(recommendations, ({projectId}) => projectId)).map(([projectId, recommendations]) => ({
    projectId: ProjectId.parse(projectId),
    recommendations,
  }))
}
